import { z } from 'zod';

export const printJobStatus = z.enum(['pending', 'completed', 'failed']);

export const printJobVariables = z.union([
  z.record(z.string(), z.unknown()),
  z.array(z.record(z.string(), z.unknown())),
]);

export const printJob = z.object({
  id: z.number(),
  printerId: z.number(),
  labelId: z.number(),
  status: printJobStatus,
  quantity: z.number(),
  labelRevision: z.string(),
  variables: printJobVariables,
  preview: z.string().min(1).nullable().optional(),
  errorMessage: z.string().nullable(),
  createdBy: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const printJobResult = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    gatewayTimeout: z.boolean().optional(),
    preview: z
      .object({
        mimeType: z.literal('image/png'),
        data: z.string().min(1),
      })
      .optional(),
  }),
  z.object({ success: z.literal(false), message: z.string() }),
]);

export type PrintJob = z.infer<typeof printJob>;
export type PrintJobVariables = z.infer<typeof printJobVariables>;
export type PrintJobResult = z.infer<typeof printJobResult>;
